var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pa-4 d-flex justify-space-between align-center"},[_c('div',[_c('Breadcrumbs',{attrs:{"headline":"Báo cáo tình trạng xe tuyến","link":[
          {
            text: 'Tình trạng xe tuyến',
            href: '../busCheckin'
          }
        ]}})],1)]),_c('v-card',{staticClass:"pa-6 mx-4 mb-6 elevation-0",attrs:{"outlined":""}},[_c('BusCheckinFilter',{ref:"busTrackingFilter"})],1),_c('v-card',{staticClass:"mx-4 elevation-0",attrs:{"outlined":""}},[_c('BusCheckinDataTable',{ref:"busCheckinDataTable",on:{"paginationChange":_vm.paginationChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }